<template>
  <section class="info-section" :style="styles">
    <div class="section-content d-flex align-items-center justify-content-center flex-column">
      <h2 class="title">{{ title }}</h2>
      <p v-if="description !== ''" class="description mb-2">{{ description }}</p>
      <slot name="action-btn"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InfoSection',
  props: {
    title: {
      type: String,
      required: true
    },
    backgroundImage: {
      type: String,
      required: true
    },
    fontColor: {
      type: String,
      required: false,
      default: '#000000'
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    styles: function () {
      return 'background-image: url(' + this.backgroundImage + '); color: ' + this.fontColor + ';';
    }
  }
};
</script>

<style lang="scss" scoped>
.info-section {
  width: 100%;
  min-height: 450px;
  height: auto;
  padding: 50px;
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  @include md {
    min-height: 350px;
    padding: 30px;
  }
  @include sm {
    padding: 15px;
  }
}
.info-section > .section-content {
  margin: auto;
  text-align: center;
}
.info-section > .section-content > .title {
  font-size: 35px;
  margin: 25px;
  font-weight: 500;
  @include md {
    font-size: 25px;
  }
}
.info-section > .section-content > .description {
  width: 650px;
  margin: auto;
  @include lg {
    width: 70%;
  }
  @include md {
    width: 80%;
  }
  @include sm {
    width: 90%;
  }
}
.info-section > .section-content > button {
  margin: 25px;
  @include sm {
    max-width: 100%;
  }
}
</style>
